/**
 * Elementos del sidebar que NO corresponden a boards propios
 * (rutas de campaña, dashboards, etc.).
 * Se mezclan con los manifests en la generación del sidebar.
 */
export const staticSidebarItems = [
  // ALUNA > CSM
  {
    section: "ALUNA",
    group: "CSM",
    order: 2,
    title: "CREAR CAMPAÑA",
    path: "/campaign-creator",
    roles: ["Authenticated", "aluna", "aluna-management"],
  },
  {
    section: "ALUNA",
    group: "CSM",
    order: 3,
    title: "EDITAR CAMPAÑA",
    path: "/edit-campaign",
    roles: ["Authenticated", "aluna", "aluna-management"],
  },
  // ROUNDLER (top-level, not a board folder)
  {
    section: "ROUNDLER",
    group: null,
    order: 5,
    title: "CREAR CAMPAÑA",
    path: "/roundler/campaign-creator",
    roles: ["Authenticated", "roundler-admin", "master-rrss-roundler"],
  },
  {
    section: "ROUNDLER",
    group: null,
    order: 6,
    title: "EDITAR CAMPAÑA",
    path: "/roundler/edit-campaign",
    roles: ["Authenticated", "roundler-admin", "master-rrss-roundler"],
  },
  // CLIENTS
  {
    section: "CLIENTS",
    group: null,
    order: 1,
    title: "Reports",
    path: "/clients-reports",
    roles: ["Clients"],
  },
];
